import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Starburst from '@/components/generals/starburst'
import { MARQUEE_CLIENTS, MARQUEE_SERVICES } from '@/constants/landing'

interface MarqueeRowProps {
    items: Array<string>
    reverse?: boolean
}

// Two identical copies side by side, shifted by half their width, loop seamlessly.
const MarqueeRow: FC<MarqueeRowProps> = ({ items, reverse = false }): ReactNode => {
    return (
        <div
            className={cn(
                'flex w-max motion-reduce:animate-none',
                reverse ? 'animate-marquee-reverse' : 'animate-marquee'
            )}
        >
            {[0, 1].map(copy => (
                <ul
                    key={copy}
                    aria-hidden={copy === 1 ? true : undefined}
                    className='flex shrink-0 items-center'
                >
                    {items.map(item => (
                        <li key={item} className='flex items-center'>
                            <span className='px-6 whitespace-nowrap md:px-10'>
                                {item}
                            </span>
                            <Starburst className='size-[0.45em] shrink-0' />
                        </li>
                    ))}
                </ul>
            ))}
        </div>
    )
}

const MarqueeBands: FC = (): ReactNode => {
    return (
        <section
            aria-label='What we make and who we make it for'
            className='relative overflow-x-clip py-14 md:py-20'
        >
            <div className='relative z-10 -mx-[5vw] -rotate-3 border-y-2 border-foreground bg-primary py-3 font-heading text-[clamp(2.5rem,6.5vw,6rem)] leading-none font-black text-primary-foreground uppercase wdth-100 md:py-5'>
                <MarqueeRow items={MARQUEE_SERVICES} />
            </div>

            <div className='relative -mx-[5vw] -mt-3 rotate-2 bg-foreground py-3 font-heading text-[clamp(2.5rem,6.5vw,6rem)] leading-none font-black text-background uppercase wdth-100 md:-mt-6 md:py-5'>
                <MarqueeRow items={MARQUEE_CLIENTS} reverse />
            </div>
        </section>
    )
}

export default MarqueeBands
